import { Config, PollQuestions } from 'schema';
import type { Poll, Question } from 'schema/poll';
import { questionReplaceUnsafe, replaceUnsafeInput } from '../../pixel/unsafe';
import TrackingEngine from '../../trackingEngine';
import { replaceUnsafeClickMap } from './questions/ClickMapPoll/replaceUnsafeClickMap';

class PollTrackingEngine extends TrackingEngine {
  override questionsMapping: Record<
    Exclude<Poll['questions'][number]['data']['type'], 'POLL_MARKUP_AREA' | 'MEDIA_FILE_LINK' | 'POLL_SELECT_AREA'>,
    Config
  > = {
    MEDIA_FILE_AUDIO: PollQuestions.MediaFileAudio.config,
    MEDIA_FILE_TEXT: PollQuestions.MediaFileText.config,
    MEDIA_FILE_VIDEO: PollQuestions.MediaFileVideo.config,
    POLL_TEXTAREA: PollQuestions.TextareaPoll.config,
    POLL_PROTOTYPE_SCREEN: PollQuestions.PrototypeScreen.config,
    POLL_SINGLE: PollQuestions.SinglePoll.config,
    POLL_MAXDIFF: PollQuestions.MaxDiffPoll.config,
    POLL_CHOICE_CONJOINT: PollQuestions.ChoiceConjoint.config,
    POLL_MULTIPLE: PollQuestions.MultiplePoll.config,
    POLL_SINGLE_FROM_PICTURE: PollQuestions.SingleFromPicturePoll.config,
    POLL_MULTIPLE_FROM_PICTURE: PollQuestions.MultipleFromPicturePoll.config,
    POLL_RANK: PollQuestions.RankPoll.config,
    POLL_RATING_DIGITS: PollQuestions.RatingDigitsPoll.config,
    POLL_RATING_LIKE: PollQuestions.RatingLikePoll.config,
    POLL_RATING_SLIDER: PollQuestions.RatingSliderPoll.config,
    POLL_RATING_SMILIES: PollQuestions.RatingSmiliesPoll.config,
    POLL_RATING_STARS: PollQuestions.RatingStarsPoll.config,
    POLL_SELECT: PollQuestions.SelectPoll.config,
    POLL_MULTIPLE_SELECT: PollQuestions.MultipleSelectPoll.config,
    MATRIX_POLL_SINGLE: PollQuestions.MatrixSinglePoll.config,
    MATRIX_POLL_MULTIPLE: PollQuestions.MatrixMultiplePoll.config,
    MATRIX_POLL_RATING_DIGITS: PollQuestions.MatrixRatingDigitsPoll.config,
    MATRIX_POLL_RATING_STARS: PollQuestions.MatrixRatingStarsPoll.config,
    POLL_CLICK_MAP: PollQuestions.ClickMapPoll.config,
    // POLL_MARKUP_AREA: PollQuestions.undefined.config, // deprecated
    // POLL_SELECT_AREA: PollQuestions.undefined.config, // deprecated
    POLL_FILE: PollQuestions.FilePoll.config,
    MEDIA_FILE_ANY: PollQuestions.MediaFileAny.config,
    MEDIA_FILE_IMAGE: PollQuestions.MediaFileImage.config,
    // MEDIA_FILE_LINK: PollQuestions.undefined.config, // заменяется реальными медиафайлами в pollPreStartTransformer
    POLL_AUTH: PollQuestions.AuthStep.config,
    POLL_CARD_SORTING_CATEGORY: PollQuestions.CardSortingCategoryPoll.config,
    POLL_SWITCH: PollQuestions.SwitchPoll.config,
    POLL_BINARY: PollQuestions.BinaryPoll.config,
  };
  override async questionReplaceUnsafeInput(
    question: { data: { type: string } },
    text: string | undefined,
  ): Promise<string | undefined> {
    if (text === undefined) return undefined;
    if (!questionReplaceUnsafe(question as Question)) return text;

    switch (question.data.type) {
      case 'POLL_FILE':
        return text;
      case 'POLL_CLICK_MAP':
        return replaceUnsafeClickMap(text, replaceUnsafeInput);
      default:
        return replaceUnsafeInput(text);
    }
  }
}

export const trackingEngine = new PollTrackingEngine();
